"use client";

import { FC } from "react";

import { useStyles } from "./styles";
import { CategoryQuizLeaderboardItem } from "@/types/quiz";
import PlayerCard from "@/components/quiz/lobby/PlayerCard";

interface CategoryLeaderboardRowProps {
  leaderboardItem: CategoryQuizLeaderboardItem;
  userResult?: string | null;
}

const CategoryLeaderboardRow: FC<CategoryLeaderboardRowProps> = ({
  leaderboardItem,
  userResult,
}) => {
  const isUserResult = userResult === leaderboardItem.resultValue;
  const { classes } = useStyles({ isUserResult });

  const additionalPlayers =
    leaderboardItem.players && leaderboardItem.players.length > 6
      ? leaderboardItem.players.length - 6
      : 0;

  return (
    <div className={classes.container}>
      <div className={classes.contentLeft}>
        <div className={classes.rank}>
          <p className={classes.rankLabel}>{leaderboardItem.rank}</p>
        </div>
        <img
          src={leaderboardItem.relatedImageUrl || ""}
          alt={leaderboardItem.resultValue}
          className={classes.thumbnail}
        />
        <p className={classes.resultValue}>{leaderboardItem.resultValue}</p>
      </div>
      {leaderboardItem.players !== undefined ? (
        <div className={classes.players}>
          {leaderboardItem.players.slice(0, 6).map((player, index) => (
            <div key={player.name} className={classes.player}>
              <PlayerCard
                index={index}
                avatarUrl={player.avatarUrl}
                name={player.name}
                hideLabel
                size="small"
              />
            </div>
          ))}
          {additionalPlayers > 0 && (
            <p className={classes.additionalPlayers}>+{additionalPlayers}</p>
          )}
        </div>
      ) : (
        <p className={classes.score}>{leaderboardItem.score}</p>
      )}
    </div>
  );
};

export default CategoryLeaderboardRow;
